import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ServiceVariantModel} from "../../../../models/ServiceVariantModel";
import {FilterAbstractModel} from "../../../../models/FilterAbstractModel";

@Component({
  selector: 'app-milestone-number-filter',
  templateUrl: './milestone-number-filter.component.html',
  styleUrls: ['./milestone-number-filter.component.scss']
})
export class MilestoneNumberFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  optionSelected: any;

  @Input() milestoneSelected: ServiceVariantModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges (changes: SimpleChanges) {
    this.optionSelected = this.milestoneSelected;
  }

  ngOnDestroy(): void {
  }

}
